/*
 * Cart upsell (Marlow & Grace) — "Pair this with your trainer".
 * Gedelegeerde listeners op document, zodat ze één keer geregistreerd worden
 * en elke Horizon cart-morph overleven (inline scripts draaien niet na morph).
 * "+ Add" voegt het gekozen variant toe via /cart/add.js en laat Horizon de
 * cart herrenderen via een 'cart:update'-event (cart-items-component vangt dit
 * op en doet sectionRenderer.renderSection). Daarna verdwijnt de upsell vanzelf,
 * want het product zit dan in de cart.
 */
(function () {
  if (window.__orthoshiftCartUpsellBound) return;
  window.__orthoshiftCartUpsellBound = true;

  document.addEventListener('click', async function (e) {
    const btn = e.target.closest && e.target.closest('[data-upsell-add]');
    if (!btn) return;
    const root = btn.closest('.cart-upsell');
    const variant = root && root.querySelector('.cart-upsell__variant');
    const id = variant && variant.value;
    if (!id || btn.dataset.loading) return;

    btn.dataset.loading = '1';
    btn.classList.add('is-loading');
    btn.disabled = true;

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }),
      });
      if (!res.ok) throw new Error('cart add failed');
      // Horizon her-rendert de cart-sectie -> upsell verdwijnt vanzelf.
      document.dispatchEvent(
        new CustomEvent('cart:update', { bubbles: true, detail: { data: { source: 'cart-upsell' } } })
      );
    } catch (err) {
      delete btn.dataset.loading;
      btn.classList.remove('is-loading');
      btn.disabled = false;
      const lbl = btn.querySelector('.cart-upsell__add-label');
      if (lbl) lbl.textContent = 'Try again';
    }
  });

  // Prijs (en doorgestreepte was-prijs) bijwerken bij variant-keuze.
  document.addEventListener('change', function (e) {
    const sel = e.target.closest && e.target.closest('select.cart-upsell__variant');
    if (!sel) return;
    const root = sel.closest('.cart-upsell');
    const opt = sel.selectedOptions && sel.selectedOptions[0];
    if (!root || !opt) return;
    const img = root.querySelector('.cart-upsell__image');
    const now = root.querySelector('[data-upsell-now]');
    const was = root.querySelector('[data-upsell-was]');
    if (img && opt.dataset.image) {
      img.src = opt.dataset.image;
      img.removeAttribute('srcset');
    }
    if (now && opt.dataset.price) now.textContent = opt.dataset.price;
    if (was) {
      if (opt.dataset.compare) {
        was.textContent = opt.dataset.compare;
        was.hidden = false;
      } else {
        was.hidden = true;
      }
    }
  });
})();
